export const LOGIN_APP_DISPLAY_NAME = {
    FACEBOOK: 'Facebook',
    GOOGLE: 'Google+',
} as const;

export const LOGIN_PLATFORM = {
    FACEBOOK: 'facebook',
    GOOGLE: 'googleplus',
} as const;
